(() => {
      const SVG_NS = 'http://www.w3.org/2000/svg';
      const app = document.getElementById('mdwstEstimator');
      const svg = document.getElementById('plannerSvg');
      const cameraGroup = document.getElementById('cameraGroup');
      const segmentLayer = document.getElementById('segmentLayer');
      const pointLayer = document.getElementById('pointLayer');
      const structureLayer = document.getElementById('structureLayer');
      const dimensionLayer = document.getElementById('dimensionLayer');
      const overlayLayer = document.getElementById('overlayLayer');

      const drawModeSelect = document.getElementById('drawModeSelect');
      const finishFenceBtn = document.getElementById('finishFenceBtn');
      const objectsMenuBtn = document.getElementById('objectsMenuBtn');
      const toggleDimensionsBtn = document.getElementById('toggleDimensionsBtn');
      const undoBtn = document.getElementById('undoBtn');
      const resetBtn = document.getElementById('resetBtn');
      const deleteBtn = document.getElementById('deleteBtn');
      const exportBtn = document.getElementById('exportBtn');
      const zoomInBtn = document.getElementById('zoomInBtn');
      const zoomOutBtn = document.getElementById('zoomOutBtn');
      const zoomResetBtn = document.getElementById('zoomResetBtn');
      const objectsPanel = document.getElementById('objectsPanel');
      const modeStatus = document.getElementById('modeStatus');
      const hintStatus = document.getElementById('hintStatus');
      const inspectorTitle = document.getElementById('inspectorTitle');
      const inspectorSub = document.getElementById('inspectorSub');
      const inspectorContent = document.getElementById('inspectorContent');
      const materialsEmpty = document.getElementById('materialsEmpty');
      const materialsTableWrap = document.getElementById('materialsTableWrap');
      const materialsBody = document.getElementById('materialsBody') || materialsTableWrap;
      const layout = document.querySelector('.layout');
      const sidebar = document.getElementById('sidebar');
      const mobileDrawerToggle = document.getElementById('mobileDrawerToggle');

      const styleConfig = {
        'Vinyl Privacy': { color: getCss('--vinyl-privacy'), family: 'vinyl', panelWidth: 8, height: 6 },
        'Vinyl Semi-Privacy': { color: getCss('--vinyl-semi'), family: 'vinyl', panelWidth: 8, height: 6 },
        'Vinyl Picket': { color: getCss('--vinyl-picket'), family: 'vinyl', panelWidth: 8, height: 4 },
        "Wood 6' Privacy": { color: getCss('--wood-privacy'), family: 'wood', panelWidth: 8, picketsPerSection: 16, height: 6 },
        "Wood 6' Shadow Box": { color: getCss('--wood-shadow'), family: 'wood', panelWidth: 8, picketsPerSection: 23, height: 6 },
        "Wood 6' Board on Board": { color: getCss('--wood-bob'), family: 'wood', panelWidth: 8, picketsPerSection: 23, height: 6 },
        'Aluminum Flat Top': { color: getCss('--alum-flat'), family: 'aluminum', panelWidth: 6, height: 4 },
        'Aluminum Spear Top': { color: getCss('--alum-spear'), family: 'aluminum', panelWidth: 6, height: 4 },
        "Chain Link 4' Galvanized": { color: '#7a7a7a', family: 'chainlink', panelWidth: 10, height: 4, chainlinkColor: 'galvanized' },
        "Chain Link 5' Galvanized": { color: '#686868', family: 'chainlink', panelWidth: 10, height: 5, chainlinkColor: 'galvanized' },
        "Chain Link 4' Black": { color: '#1f2937', family: 'chainlink', panelWidth: 10, height: 4, chainlinkColor: 'black' },
        "Chain Link 5' Black": { color: '#111827', family: 'chainlink', panelWidth: 10, height: 5, chainlinkColor: 'black' }
      };

      const BRAND_INFO = {
        company: (window.MDWST_ESTIMATOR_CONFIG && window.MDWST_ESTIMATOR_CONFIG.businessName) || 'MDWST Fence Supply',
        phone: (window.MDWST_ESTIMATOR_CONFIG && window.MDWST_ESTIMATOR_CONFIG.phone) || '317-419-2355',
        email: (window.MDWST_ESTIMATOR_CONFIG && window.MDWST_ESTIMATOR_CONFIG.email) || 'sales@mdwstfence.com',
        address1: (window.MDWST_ESTIMATOR_CONFIG && window.MDWST_ESTIMATOR_CONFIG.address1) || '1402 Sheldon St',
        cityStateZip: (window.MDWST_ESTIMATOR_CONFIG && window.MDWST_ESTIMATOR_CONFIG.cityStateZip) || 'Indianapolis, IN 46201',
        website: (window.MDWST_ESTIMATOR_CONFIG && window.MDWST_ESTIMATOR_CONFIG.website) || 'www.mdwstfence.com'
      };
      const BRAND_LOGO_ASSET_URL = (window.MDWST_ESTIMATOR_CONFIG && window.MDWST_ESTIMATOR_CONFIG.logoAssetUrl) || '';

      let interactionMode = 'idle';
      let points = [];
      let segments = [];
      let structures = [];
      let selected = null;
      let dragState = null;
      let previewPoint = null;
      let dimensionsVisible = true;
      let history = [];
      let pinchState = null;
      let clipboardSelection = null;

      const camera = { x: 0, y: 0, scale: 1, minScale: 0.5, maxScale: 3 };

      function getCss(name) { return getComputedStyle(document.documentElement).getPropertyValue(name).trim(); }
      function uid() { return 'id-' + Math.random().toString(36).slice(2, 10); }
      function round2(n) { return Math.round(n * 100) / 100; }
      function ceil2(n) { return Math.ceil(n * 100) / 100; }
      function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }
      function lerp(a, b, t) { return a + (b - a) * t; }
      function distance(a, b) { return Math.hypot(b.x - a.x, b.y - a.y); }
      function toFeet(px) { return round2(px / 10); }
      function feetToPixels(ft) { return ft * 10; }
      function getStyleMeta(style) { return styleConfig[style] || styleConfig['Vinyl Privacy']; }
      function getSegmentHeight(seg) { return getStyleMeta(seg?.style).height || 6; }
      function pointById(id) { return points.find(p => p.id === id); }
      function segmentById(id) { return segments.find(s => s.id === id); }
      function structureById(id) { return structures.find(s => s.id === id); }
      function getLastPoint() { return points[points.length - 1] || null; }
      function cloneState() { return JSON.parse(JSON.stringify({ interactionMode, points, segments, structures, selected, dimensionsVisible, camera })); }
      function pushHistory() { history.push(cloneState()); if (history.length > 100) history.shift(); }
      function restoreState(snapshot) { if (!snapshot) return; interactionMode = snapshot.interactionMode; points = snapshot.points; segments = snapshot.segments; structures = snapshot.structures; selected = snapshot.selected; dimensionsVisible = snapshot.dimensionsVisible; Object.assign(camera, snapshot.camera); previewPoint = null; render(); }

      function updateDrawingControls() {
        if (drawModeSelect) {
          if (interactionMode === 'draw-start') drawModeSelect.value = 'draw-start';
          else if (interactionMode === 'draw-continue') drawModeSelect.value = 'draw-continue';
          else drawModeSelect.value = 'idle';
        }
        finishFenceBtn?.classList.toggle('active', interactionMode === 'draw-start' || interactionMode === 'draw-continue');
      }

      function setMode(mode, text, hint) {
        interactionMode = mode;
        modeStatus.textContent = text || 'Ready';
        hintStatus.textContent = hint || 'Draw around the property until finished.';
        updateDrawingControls();
      }

      function finishDrawing() {
        previewPoint = null;
        selected = null;
        objectsPanel.hidden = true;
        objectsMenuBtn.classList.remove('active');
        setMode('idle', 'Drawing Finished', 'Tap any run, gate, point, or object to edit it.');
        render();
      }

      function addPoint(world) {
        const p = { id: uid(), x: clamp(world.x, 0, 1800), y: clamp(world.y, 0, 1100) };
        points.push(p);
        return p;
      }

      function addSegment(startPointId, endPointId) {
        const seg = {
          id: uid(),
          startPointId,
          endPointId,
          style: 'Vinyl Privacy',
          installMethod: 'Concrete Set',
          notes: '',
          customLengthFeet: null,
          gates: []
        };
        segments.push(seg);
        return seg;
      }

      function segmentLengthFeet(seg) {
        const a = pointById(seg.startPointId);
        const b = pointById(seg.endPointId);
        if (!a || !b) return 0;
        return seg.customLengthFeet || toFeet(distance(a, b));
      }

      function gateWidthTotal(seg) {
        return (seg.gates || []).reduce((sum, gate) => sum + Number(gate.width || 0), 0);
      }

      function usableFenceLengthFt(seg) {
        return Math.max(0, segmentLengthFeet(seg) - gateWidthTotal(seg));
      }

      function getPanels(seg) {
        const meta = getStyleMeta(seg.style);
        return Math.ceil(usableFenceLengthFt(seg) / meta.panelWidth);
      }

      function gatePicketsForStyle(style, widthFt) {
        const meta = getStyleMeta(style);
        if (meta.family !== 'wood') return 0;
        return Math.max(1, Math.ceil((meta.picketsPerSection || 0) * (Number(widthFt || 0) / meta.panelWidth)));
      }

      function gateStats(seg) {
        const gates = seg.gates || [];
        return {
          count: gates.length,
          hinges: gates.length,
          latches: gates.length,
          stiffeners: gates.length,
          woodGateRails: gates.length * 3,
          woodGateBraces: gates.length,
          woodGatePickets: gates.reduce((sum, gate) => sum + gatePicketsForStyle(seg.style, gate.width), 0)
        };
      }

      function getSegmentPoints(seg) {
        return { a: pointById(seg.startPointId), b: pointById(seg.endPointId) };
      }

      function pointUsageForStyle(style) {
        const usage = new Map();
        segments.filter(seg => seg.style === style).forEach(seg => {
          [seg.startPointId, seg.endPointId].forEach(pointId => {
            if (!usage.has(pointId)) usage.set(pointId, []);
            usage.get(pointId).push(seg.id);
          });
        });
        return usage;
      }

      function componentDataForSegments(segmentList) {
        const byId = new Map(segmentList.map(seg => [seg.id, seg]));
        const pointUsage = new Map();
        segmentList.forEach(seg => {
          [seg.startPointId, seg.endPointId].forEach(pointId => {
            if (!pointUsage.has(pointId)) pointUsage.set(pointId, []);
            pointUsage.get(pointId).push(seg.id);
          });
        });
        const seen = new Set();
        const components = [];

        segmentList.forEach(seg => {
          if (seen.has(seg.id)) return;
          const stack = [seg.id];
          const ids = [];
          seen.add(seg.id);
          while (stack.length) {
            const currentId = stack.pop();
            const current = byId.get(currentId);
            if (!current) continue;
            ids.push(currentId);
            [current.startPointId, current.endPointId].forEach(pointId => {
              (pointUsage.get(pointId) || []).forEach(nextId => {
                if (!seen.has(nextId)) {
                  seen.add(nextId);
                  stack.push(nextId);
                }
              });
            });
          }
          components.push(ids.map(id => byId.get(id)).filter(Boolean));
        });

        return { components, pointUsage };
      }

      function cornerCountForSegments(segmentList) {
        const { pointUsage } = componentDataForSegments(segmentList);
        let corners = 0;
        pointUsage.forEach((segIds, pointId) => {
          if (segIds.length !== 2) return;
          const point = pointById(pointId);
          const segA = segmentList.find(seg => seg.id === segIds[0]);
          const segB = segmentList.find(seg => seg.id === segIds[1]);
          if (!point || !segA || !segB) return;
          const otherA = segA.startPointId === pointId ? pointById(segA.endPointId) : pointById(segA.startPointId);
          const otherB = segB.startPointId === pointId ? pointById(segB.endPointId) : pointById(segB.startPointId);
          if (!otherA || !otherB) return;
          const v1x = otherA.x - point.x;
          const v1y = otherA.y - point.y;
          const v2x = otherB.x - point.x;
          const v2y = otherB.y - point.y;
          const mag1 = Math.hypot(v1x, v1y);
          const mag2 = Math.hypot(v2x, v2y);
          if (!mag1 || !mag2) return;
          const dot = (v1x * v2x + v1y * v2y) / (mag1 * mag2);
          const angle = Math.acos(clamp(dot, -1, 1));
          if (Math.abs(Math.PI - angle) > 0.2) corners += 1;
        });
        return corners;
      }

      function componentSectionsForSegments(segmentList, panelWidth) {
        return segmentList.reduce((sum, seg) => {
          return sum + Math.ceil(usableFenceLengthFt(seg) / panelWidth);
        }, 0);
      }

      function componentDataForStyle(style) {
        const styleSegments = segments.filter(seg => seg.style === style);
        const byId = new Map(styleSegments.map(seg => [seg.id, seg]));
        const pointUsage = pointUsageForStyle(style);
        const seen = new Set();
        const components = [];

        styleSegments.forEach(seg => {
          if (seen.has(seg.id)) return;
          const stack = [seg.id];
          const ids = [];
          seen.add(seg.id);
          while (stack.length) {
            const currentId = stack.pop();
            const current = byId.get(currentId);
            if (!current) continue;
            ids.push(currentId);
            [current.startPointId, current.endPointId].forEach(pointId => {
              (pointUsage.get(pointId) || []).forEach(nextId => {
                if (!seen.has(nextId)) {
                  seen.add(nextId);
                  stack.push(nextId);
                }
              });
            });
          }
          components.push(ids.map(id => byId.get(id)).filter(Boolean));
        });
        return components;
      }

      function cornerCountForStyle(style) {
        const pointUsage = pointUsageForStyle(style);
        let corners = 0;
        pointUsage.forEach((segIds, pointId) => {
          if (segIds.length !== 2) return;
          const point = pointById(pointId);
          const segA = segmentById(segIds[0]);
          const segB = segmentById(segIds[1]);
          if (!point || !segA || !segB) return;
          const otherA = segA.startPointId === pointId ? pointById(segA.endPointId) : pointById(segA.startPointId);
          const otherB = segB.startPointId === pointId ? pointById(segB.endPointId) : pointById(segB.startPointId);
          if (!otherA || !otherB) return;
          const v1x = otherA.x - point.x;
          const v1y = otherA.y - point.y;
          const v2x = otherB.x - point.x;
          const v2y = otherB.y - point.y;
          const mag1 = Math.hypot(v1x, v1y);
          const mag2 = Math.hypot(v2x, v2y);
          if (!mag1 || !mag2) return;
          const dot = (v1x * v2x + v1y * v2y) / (mag1 * mag2);
          const angle = Math.acos(clamp(dot, -1, 1));
          if (Math.abs(Math.PI - angle) > 0.2) corners += 1;
        });
        return corners;
      }

      function componentSectionsForStyle(style) {
        const meta = getStyleMeta(style);
        const styleSegments = segments.filter(seg => seg.style === style);
        return styleSegments.reduce((sum, seg) => {
          return sum + Math.ceil(usableFenceLengthFt(seg) / meta.panelWidth);
        }, 0);
      }

      function getSegmentAngle(seg) {
        const { a, b } = getSegmentPoints(seg);
        if (!a || !b) return 0;
        return Math.atan2(b.y - a.y, b.x - a.x);
      }

      function getGateWorldPosition(seg, gate) {
        const { a, b } = getSegmentPoints(seg);
        if (!a || !b) return null;
        return { x: lerp(a.x, b.x, gate.position), y: lerp(a.y, b.y, gate.position) };
      }

      function projectPointToSegment(px, py, ax, ay, bx, by) {
        const abx = bx - ax;
        const aby = by - ay;
        const abLenSq = abx * abx + aby * aby;
        if (abLenSq === 0) return 0;
        const apx = px - ax;
        const apy = py - ay;
        return clamp((apx * abx + apy * aby) / abLenSq, 0, 1);
      }

      function getStructureTemplate(type, world) {
        const map = {
          tree: { id: uid(), type, label: 'Tree', x: world.x, y: world.y, size: 48 },
          stump: { id: uid(), type, label: 'Stump', x: world.x, y: world.y, size: 22 },
          house: { id: uid(), type, label: 'House', x: world.x - 130, y: world.y - 80, width: 260, height: 160 },
          shed: { id: uid(), type, label: 'Shed', x: world.x - 80, y: world.y - 55, width: 160, height: 110 },
          pool: { id: uid(), type, label: 'Pool', x: world.x - 110, y: world.y - 60, width: 220, height: 120 },
          patio: { id: uid(), type, label: 'Patio', x: world.x - 95, y: world.y - 50, width: 190, height: 100 },
          ac: { id: uid(), type, label: 'A/C Unit', x: world.x - 34, y: world.y - 34, width: 68, height: 68 },
          utility: { id: uid(), type, label: 'Utility Box', x: world.x - 38, y: world.y - 28, width: 76, height: 56 },
          other: { id: uid(), type, label: 'Structure', x: world.x - 75, y: world.y - 50, width: 150, height: 100 }
        };
        return map[type] || map.other;
      }

      function applyCamera() {
        cameraGroup.setAttribute('transform', `translate(${camera.x} ${camera.y}) scale(${camera.scale})`);
      }

      function screenToWorld(clientX, clientY) {
        const pt = svg.createSVGPoint();
        pt.x = clientX;
        pt.y = clientY;
        const local = pt.matrixTransform(svg.getScreenCTM().inverse());
        return { x: (local.x - camera.x) / camera.scale, y: (local.y - camera.y) / camera.scale };
      }

      function clearLayers() {
        segmentLayer.innerHTML = '';
        pointLayer.innerHTML = '';
        structureLayer.innerHTML = '';
        dimensionLayer.innerHTML = '';
        overlayLayer.innerHTML = '';
      }

      function renderCanvasOnly() {
        applyCamera();
        clearLayers();
        renderSegments();
        renderPoints();
        renderStructures();
        renderDimensions();
      }

      function render() {
        renderCanvasOnly();
        renderInspector();
        renderMaterials();
      }

      function renderSegments() {
        segments.forEach(seg => {
          const { a, b } = getSegmentPoints(seg);
          if (!a || !b) return;
          const meta = getStyleMeta(seg.style);

          const visible = document.createElementNS(SVG_NS, 'line');
          visible.setAttribute('x1', a.x); visible.setAttribute('y1', a.y);
          visible.setAttribute('x2', b.x); visible.setAttribute('y2', b.y);
          visible.setAttribute('stroke', meta.color);
          visible.setAttribute('class', 'svg-fence');
          visible.style.pointerEvents = 'none';
          segmentLayer.appendChild(visible);

          const hit = document.createElementNS(SVG_NS, 'line');
          hit.setAttribute('x1', a.x); hit.setAttribute('y1', a.y);
          hit.setAttribute('x2', b.x); hit.setAttribute('y2', b.y);
          hit.setAttribute('class', 'svg-hit');
          hit.dataset.type = 'segment';
          hit.dataset.id = seg.id;
          segmentLayer.appendChild(hit);

          const label = document.createElementNS(SVG_NS, 'text');
          label.setAttribute('x', (a.x + b.x) / 2);
          label.setAttribute('y', (a.y + b.y) / 2 - 10);
          label.setAttribute('text-anchor', 'middle');
          label.setAttribute('font-size', '14');
          label.setAttribute('font-weight', '700');
          label.setAttribute('fill', meta.color);
          label.setAttribute('paint-order', 'stroke');
          label.setAttribute('stroke', '#fff');
          label.setAttribute('stroke-width', '4');
          label.style.pointerEvents = 'none';
          label.textContent = `${segmentLengthFeet(seg)} ft`;
          segmentLayer.appendChild(label);

          if (seg.notes) {
            const note = document.createElementNS(SVG_NS, 'text');
            note.setAttribute('x', (a.x + b.x) / 2);
            note.setAttribute('y', (a.y + b.y) / 2 + 12);
            note.setAttribute('text-anchor', 'middle');
            note.setAttribute('font-size', '11');
            note.setAttribute('fill', '#475569');
            note.setAttribute('paint-order', 'stroke');
            note.setAttribute('stroke', '#fff');
            note.setAttribute('stroke-width', '4');
            note.style.pointerEvents = 'none';
            note.textContent = seg.notes.slice(0, 36);
            segmentLayer.appendChild(note);
          }

          (seg.gates || []).forEach(gate => {
            const gatePos = getGateWorldPosition(seg, gate);
            if (!gatePos) return;
            const angle = getSegmentAngle(seg);
            const gatePx = feetToPixels(gate.width || 4);
            const halfGate = gatePx / 2;
            const dx = Math.cos(angle), dy = Math.sin(angle);
            const nx = -dy, ny = dx;
            const x1 = gatePos.x - dx * halfGate;
            const y1 = gatePos.y - dy * halfGate;
            const x2 = gatePos.x + dx * halfGate;
            const y2 = gatePos.y + dy * halfGate;

            const gateLine = document.createElementNS(SVG_NS, 'line');
            gateLine.setAttribute('x1', x1); gateLine.setAttribute('y1', y1);
            gateLine.setAttribute('x2', x2); gateLine.setAttribute('y2', y2);
            gateLine.setAttribute('stroke', '#111827');
            gateLine.setAttribute('stroke-width', '9');
            gateLine.setAttribute('stroke-linecap', 'round');
            gateLine.setAttribute('vector-effect', 'non-scaling-stroke');
            gateLine.dataset.type = 'gate';
            gateLine.dataset.segmentId = seg.id;
            gateLine.dataset.gateId = gate.id;
            segmentLayer.appendChild(gateLine);

            const gateHit = document.createElementNS(SVG_NS, 'line');
            gateHit.setAttribute('x1', x1); gateHit.setAttribute('y1', y1);
            gateHit.setAttribute('x2', x2); gateHit.setAttribute('y2', y2);
            gateHit.setAttribute('stroke', 'transparent');
            gateHit.setAttribute('stroke-width', '26');
            gateHit.setAttribute('vector-effect', 'non-scaling-stroke');
            gateHit.dataset.type = 'gate';
            gateHit.dataset.segmentId = seg.id;
            gateHit.dataset.gateId = gate.id;
            segmentLayer.appendChild(gateHit);

            const hingeT = gate.hingeSide === 'right' ? 1 : 0;
            const hingeX = lerp(x1, x2, hingeT);
            const hingeY = lerp(y1, y2, hingeT);
            const hinge = document.createElementNS(SVG_NS, 'circle');
            hinge.setAttribute('cx', hingeX);
            hinge.setAttribute('cy', hingeY);
            hinge.setAttribute('r', '6');
            hinge.setAttribute('fill', '#2563eb');
            hinge.style.pointerEvents = 'none';
            segmentLayer.appendChild(hinge);

            const closedVx = gate.hingeSide === 'right' ? -dx * gatePx : dx * gatePx;
            const closedVy = gate.hingeSide === 'right' ? -dy * gatePx : dy * gatePx;
            const closedEndX = hingeX + closedVx;
            const closedEndY = hingeY + closedVy;
            const rotateSign = gate.swing === 'out' ? -1 : 1;
            const openVx = -rotateSign * closedVy;
            const openVy = rotateSign * closedVx;
            const openEndX = hingeX + openVx;
            const openEndY = hingeY + openVy;

            const leaf = document.createElementNS(SVG_NS, 'line');
            leaf.setAttribute('x1', hingeX);
            leaf.setAttribute('y1', hingeY);
            leaf.setAttribute('x2', openEndX);
            leaf.setAttribute('y2', openEndY);
            leaf.setAttribute('stroke', '#2563eb');
            leaf.setAttribute('stroke-width', '3');
            leaf.setAttribute('stroke-linecap', 'round');
            leaf.setAttribute('stroke-dasharray', '7 5');
            leaf.style.pointerEvents = 'none';
            segmentLayer.appendChild(leaf);

            const swingArc = document.createElementNS(SVG_NS, 'path');
            swingArc.setAttribute('d', `M ${closedEndX} ${closedEndY} A ${gatePx} ${gatePx} 0 0 ${gate.swing === 'out' ? 0 : 1} ${openEndX} ${openEndY}`);
            swingArc.setAttribute('fill', 'none');
            swingArc.setAttribute('stroke', '#2563eb');
            swingArc.setAttribute('stroke-width', '2.5');
            swingArc.setAttribute('stroke-dasharray', '6 5');
            swingArc.style.pointerEvents = 'none';
            segmentLayer.appendChild(swingArc);
          });
        });
      }

      function renderPoints() {
        points.forEach((p, idx) => {
          const c = document.createElementNS(SVG_NS, 'circle');
          c.setAttribute('cx', p.x);
          c.setAttribute('cy', p.y);
          c.setAttribute('r', 8);
          c.setAttribute('class', 'svg-node' + (idx === points.length - 1 ? ' last' : ''));
          c.dataset.type = 'point';
          c.dataset.id = p.id;
          pointLayer.appendChild(c);
        });

        if (interactionMode === 'draw-continue' && previewPoint && points.length) {
          const last = getLastPoint();
          const line = document.createElementNS(SVG_NS, 'line');
          line.setAttribute('x1', last.x);
          line.setAttribute('y1', last.y);
          line.setAttribute('x2', previewPoint.x);
          line.setAttribute('y2', previewPoint.y);
          line.setAttribute('class', 'svg-preview');
          overlayLayer.appendChild(line);

          const label = document.createElementNS(SVG_NS, 'text');
          label.setAttribute('x', (last.x + previewPoint.x) / 2);
          label.setAttribute('y', (last.y + previewPoint.y) / 2 - 14);
          label.setAttribute('text-anchor', 'middle');
          label.setAttribute('font-size', '15');
          label.setAttribute('font-weight', '800');
          label.setAttribute('fill', '#111827');
          label.setAttribute('paint-order', 'stroke');
          label.setAttribute('stroke', '#fff');
          label.setAttribute('stroke-width', '4');
          label.textContent = `${toFeet(distance(last, previewPoint))} ft`;
          overlayLayer.appendChild(label);
        }
      }

      function renderStructures() {
        structures.forEach(obj => {
          const group = document.createElementNS(SVG_NS, 'g');

          if (obj.type === 'tree' || obj.type === 'stump') {
            const circle = document.createElementNS(SVG_NS, 'circle');
            circle.setAttribute('cx', obj.x);
            circle.setAttribute('cy', obj.y);
            circle.setAttribute('r', obj.size);
            circle.setAttribute('fill', obj.type === 'stump' ? '#8c6844' : '#6aa36a');
            circle.setAttribute('stroke', '#496b49');
            circle.setAttribute('stroke-width', '3');
            circle.dataset.type = 'structure';
            circle.dataset.id = obj.id;
            group.appendChild(circle);

            if (obj.type === 'tree') {
              const trunk = document.createElementNS(SVG_NS, 'rect');
              trunk.setAttribute('x', obj.x - 8);
              trunk.setAttribute('y', obj.y + obj.size - 6);
              trunk.setAttribute('width', 16);
              trunk.setAttribute('height', 24);
              trunk.setAttribute('fill', '#7b4a28');
              trunk.style.pointerEvents = 'none';
              group.appendChild(trunk);
            }

            if (selected?.kind === 'structure' && selected.id === obj.id) {
              const handle = document.createElementNS(SVG_NS, 'circle');
              handle.setAttribute('cx', obj.x + obj.size);
              handle.setAttribute('cy', obj.y);
              handle.setAttribute('r', 8);
              handle.setAttribute('class', 'svg-handle');
              handle.dataset.type = 'resize';
              handle.dataset.id = obj.id;
              group.appendChild(handle);
            }
          } else {
            const rect = document.createElementNS(SVG_NS, 'rect');
            rect.setAttribute('x', obj.x);
            rect.setAttribute('y', obj.y);
            rect.setAttribute('width', obj.width);
            rect.setAttribute('height', obj.height);
            rect.setAttribute('rx', obj.type === 'pool' ? 28 : 12);
            rect.setAttribute('fill', obj.type === 'pool' ? '#9bd0ff' : obj.type === 'patio' ? '#ddd8d2' : obj.type === 'ac' ? '#d5dae1' : obj.type === 'utility' ? '#e7ebef' : '#ced6df');
            rect.setAttribute('stroke', '#6b7280');
            rect.setAttribute('stroke-width', '3');
            rect.dataset.type = 'structure';
            rect.dataset.id = obj.id;
            group.appendChild(rect);

            if (obj.type === 'house' || obj.type === 'shed') {
              const roof = document.createElementNS(SVG_NS, 'polygon');
              roof.setAttribute('points', `${obj.x - 10},${obj.y} ${obj.x + obj.width / 2},${obj.y - 40} ${obj.x + obj.width + 10},${obj.y}`);
              roof.setAttribute('fill', '#7a5439');
              roof.style.pointerEvents = 'none';
              group.insertBefore(roof, rect);
            }

            if (selected?.kind === 'structure' && selected.id === obj.id) {
              const handle = document.createElementNS(SVG_NS, 'circle');
              handle.setAttribute('cx', obj.x + obj.width);
              handle.setAttribute('cy', obj.y + obj.height);
              handle.setAttribute('r', 8);
              handle.setAttribute('class', 'svg-handle');
              handle.dataset.type = 'resize';
              handle.dataset.id = obj.id;
              group.appendChild(handle);
            }
          }

          const text = document.createElementNS(SVG_NS, 'text');
          const tx = obj.size ? obj.x : obj.x + obj.width / 2;
          const ty = obj.size ? obj.y - obj.size - 10 : obj.y - 10;
          text.setAttribute('x', tx);
          text.setAttribute('y', ty);
          text.setAttribute('text-anchor', 'middle');
          text.setAttribute('font-size', '11');
          text.setAttribute('font-weight', '700');
          text.setAttribute('fill', '#334155');
          text.setAttribute('paint-order', 'stroke');
          text.setAttribute('stroke', '#fff');
          text.setAttribute('stroke-width', '4');
          text.style.pointerEvents = 'none';
          text.textContent = obj.label;
          group.appendChild(text);

          structureLayer.appendChild(group);
        });
      }

      function renderDimensions() {
        if (!dimensionsVisible) return;
        segments.forEach(seg => {
          const { a, b } = getSegmentPoints(seg);
          if (!a || !b) return;
          const line = document.createElementNS(SVG_NS, 'line');
          line.setAttribute('x1', a.x);
          line.setAttribute('y1', a.y - 22);
          line.setAttribute('x2', b.x);
          line.setAttribute('y2', b.y - 22);
          line.setAttribute('stroke', '#334155');
          line.setAttribute('stroke-width', '2');
          line.setAttribute('stroke-dasharray', '8 5');
          dimensionLayer.appendChild(line);
        });
      }


      function updateDeleteButton() {
        if (!deleteBtn) return;
        const labels = { segment: 'Delete Run', gate: 'Delete Gate', structure: 'Delete Object', point: 'Delete Point' };
        const enabled = Boolean(selected);
        deleteBtn.disabled = !enabled;
        deleteBtn.textContent = enabled ? (labels[selected.kind] || 'Delete') : 'Delete';
      }

      function deletePoint(id) {
        const connected = segments.filter(seg => seg.startPointId === id || seg.endPointId === id);
        if (connected.length) {
          connected.forEach(seg => deleteSegment(seg.id));
          return;
        }
        pushHistory();
        points = points.filter(point => point.id !== id);
        selected = null;
        render();
      }

      function deleteSelection() {
        if (!selected) return;
        if (selected.kind === 'segment') return deleteSegment(selected.id);
        if (selected.kind === 'gate') {
          const seg = segmentById(selected.segmentId);
          if (!seg) return;
          pushHistory();
          seg.gates = (seg.gates || []).filter(gate => gate.id !== selected.gateId);
          selected = { kind: 'segment', id: seg.id };
          return render();
        }
        if (selected.kind === 'structure') return deleteStructure(selected.id);
        if (selected.kind === 'point') return deletePoint(selected.id);
      }

      function cloneWithIds(value) {
        const clone = JSON.parse(JSON.stringify(value));
        if (clone.id) clone.id = uid();
        if (clone.gates) clone.gates = clone.gates.map(gate => ({ ...gate, id: uid() }));
        return clone;
      }

      function copySelection() {
        if (!selected) return;
        if (selected.kind === 'segment') {
          const seg = segmentById(selected.id);
          if (seg) seg.installMethod = normalizeInstallMethod(seg.installMethod);
          if (!seg) return;
          clipboardSelection = { kind: 'segment', data: cloneWithIds(seg) };
          return;
        }
        if (selected.kind === 'structure') {
          const obj = structureById(selected.id);
          if (!obj) return;
          clipboardSelection = { kind: 'structure', data: cloneWithIds(obj) };
          return;
        }
        if (selected.kind === 'gate') {
          const seg = segmentById(selected.segmentId);
          const gate = seg?.gates?.find(g => g.id === selected.gateId);
          if (!gate) return;
          clipboardSelection = { kind: 'gate', segmentId: selected.segmentId, data: cloneWithIds(gate) };
        }
      }

      function pasteSelection() {
        if (!clipboardSelection) return;
        pushHistory();
        if (clipboardSelection.kind === 'structure') {
          const obj = cloneWithIds(clipboardSelection.data);
          if ('x' in obj) obj.x += 40;
          if ('y' in obj) obj.y += 40;
          structures.push(obj);
          selected = { kind: 'structure', id: obj.id };
          return render();
        }
        if (clipboardSelection.kind === 'segment') {
          const seg = clipboardSelection.data;
          const a = pointById(seg.startPointId);
          const b = pointById(seg.endPointId);
          if (!a || !b) return;
          const p1 = addPoint({ x: a.x + 40, y: a.y + 40 });
          const p2 = addPoint({ x: b.x + 40, y: b.y + 40 });
          const newSeg = { ...cloneWithIds(seg), startPointId: p1.id, endPointId: p2.id };
          segments.push(newSeg);
          selected = { kind: 'segment', id: newSeg.id };
          return render();
        }
        if (clipboardSelection.kind === 'gate') {
          const targetSeg = segmentById(selected?.kind === 'segment' ? selected.id : clipboardSelection.segmentId);
          if (!targetSeg) return;
          const gate = cloneWithIds(clipboardSelection.data);
          gate.position = clamp((Number(gate.position || 0.5) + 0.08), 0.08, 0.92);
          if (!targetSeg.gates) targetSeg.gates = [];
          targetSeg.gates.push(gate);
          selected = { kind: 'gate', segmentId: targetSeg.id, gateId: gate.id };
          return render();
        }
      }

      function focusInspectorOnMobile() {
        if (window.innerWidth > 760) return;
        requestAnimationFrame(() => {
          sidebar.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      function normalizeInstallMethod(value) {
        return value === 'No-Dig / Octo Ring' ? 'No-Dig' : value;
      }

      function renderInspector() {
        if (!selected) {
          inspectorTitle.textContent = 'Project Controls';
          inspectorSub.textContent = interactionMode.startsWith('draw') ? 'Finish drawing first, then tap any fence run, gate, or structure to edit it.' : 'Tap a fence run, gate, or structure to edit it.';
          inspectorContent.innerHTML = `
            <div class="empty-state">
              Start the fence, keep clicking or tapping around the property until finished, then edit any run or structure here. There is no select mode button to fight with. Just tap and drag what you need.
            </div>
          `;
          return;
        }

        if (selected.kind === 'segment') {
          const seg = segmentById(selected.id);
          if (!seg) return;
          inspectorTitle.textContent = `Segment ${segments.findIndex(s => s.id === seg.id) + 1}`;
          inspectorSub.textContent = 'Fence run settings, notes, and gate placement.';
          inspectorContent.innerHTML = `
            <div class="field-grid">
              <div class="field">
                <label>Fence Style</label>
                <select class="select" id="segStyle">
                  ${Object.keys(styleConfig).map(style => `<option value="${style}" ${seg.style === style ? 'selected' : ''}>${style}</option>`).join('')}
                </select>
              </div>
              <div class="field">
                <label>Install Method</label>
                <select class="select" id="segInstall">
                  <option value="Concrete Set" ${seg.installMethod === 'Concrete Set' ? 'selected' : ''}>Concrete Set</option>
                  <option value="No-Dig" ${seg.installMethod === 'No-Dig' ? 'selected' : ''}>No-Dig</option>
                  <option value="PostMaster" ${seg.installMethod === 'PostMaster' ? 'selected' : ''}>PostMaster</option>
                </select>
              </div>
              <div class="field">
                <label>Length (ft)</label>
                <input class="input" id="segLength" type="number" min="1" step="0.1" value="${segmentLengthFeet(seg)}">
              </div>
              <div class="field full">
                <label>Notes</label>
                <textarea class="textarea" id="segNotes" placeholder="Add a note for this run">${seg.notes || ''}</textarea>
              </div>
            </div>
            <div class="inline-actions">
              <span class="chip">Panels: ${getPanels(seg)}</span>
              <button class="btn" id="addGateBtn">Add Gate</button>
              <button class="btn danger" id="deleteSegmentBtn">Delete Segment</button>
            </div>
            <div class="muted">Gates stay on the fence line and can be dragged where the user wants them.</div>
          `;

          document.getElementById('segStyle').addEventListener('change', e => { seg.style = e.target.value; renderCanvasOnly(); renderInspector(); renderMaterials(); });
          document.getElementById('segInstall').addEventListener('change', e => { seg.installMethod = e.target.value; renderMaterials(); });
          document.getElementById('segLength').addEventListener('input', e => { seg.customLengthFeet = Number(e.target.value || 0); renderCanvasOnly(); renderMaterials(); });
          document.getElementById('segNotes').addEventListener('input', e => { seg.notes = e.target.value; renderCanvasOnly(); renderMaterials(); });
          document.getElementById('addGateBtn').addEventListener('click', () => {
            pushHistory();
            seg.gates.push({ id: uid(), width: 4, position: 0.5, hingeSide: 'left', swing: 'in' });
            const newGate = seg.gates[seg.gates.length - 1];
            selected = { kind: 'gate', segmentId: seg.id, gateId: newGate.id };
            render();
          });
          document.getElementById('deleteSegmentBtn').addEventListener('click', () => deleteSegment(seg.id));
          focusInspectorOnMobile();
          return;
        }

        if (selected.kind === 'gate') {
          const seg = segmentById(selected.segmentId);
          const gate = seg?.gates?.find(g => g.id === selected.gateId);
          if (!seg || !gate) return;
          inspectorTitle.textContent = 'Gate';
          inspectorSub.textContent = 'Width, hinge side, and swing direction.';
          inspectorContent.innerHTML = `
            <div class="field-grid">
              <div class="field">
                <label>Gate Width (ft)</label>
                <input class="input" id="gateWidth" type="number" min="3" step="1" value="${gate.width}">
              </div>
              <div class="field">
                <label>Hinge Side</label>
                <select class="select" id="gateHinge">
                  <option value="left" ${gate.hingeSide === 'left' ? 'selected' : ''}>Left</option>
                  <option value="right" ${gate.hingeSide === 'right' ? 'selected' : ''}>Right</option>
                </select>
              </div>
              <div class="field">
                <label>Swing Direction</label>
                <select class="select" id="gateSwing">
                  <option value="in" ${gate.swing === 'in' ? 'selected' : ''}>In</option>
                  <option value="out" ${gate.swing === 'out' ? 'selected' : ''}>Out</option>
                </select>
              </div>
            </div>
            <div class="inline-actions">
              <button class="btn danger" id="deleteGateBtn">Delete Gate</button>
            </div>
            <div class="muted">Drag the gate directly on the fence line to move it.</div>
          `;
          document.getElementById('gateWidth').addEventListener('input', e => { gate.width = Number(e.target.value || 4); renderCanvasOnly(); renderMaterials(); });
          document.getElementById('gateHinge').addEventListener('change', e => { gate.hingeSide = e.target.value; renderCanvasOnly(); });
          document.getElementById('gateSwing').addEventListener('change', e => { gate.swing = e.target.value; renderCanvasOnly(); });
          document.getElementById('deleteGateBtn').addEventListener('click', () => {
            pushHistory();
            seg.gates = seg.gates.filter(g => g.id !== gate.id);
            selected = { kind: 'segment', id: seg.id };
            render();
          });
          focusInspectorOnMobile();
          return;
        }

        if (selected.kind === 'structure') {
          const obj = structureById(selected.id);
          if (!obj) return;
          inspectorTitle.textContent = obj.label;
          inspectorSub.textContent = 'Structure label and quick delete.';
          inspectorContent.innerHTML = `
            <div class="field-grid">
              <div class="field">
                <label>Label</label>
                <input class="input" id="objLabel" type="text" value="${obj.label}">
              </div>
              <div class="field">
                <label>Type</label>
                <input class="input" type="text" value="${obj.type}" disabled>
              </div>
            </div>
            <div class="inline-actions">
              <button class="btn danger" id="deleteObjBtn">Delete Object</button>
            </div>
          `;
          document.getElementById('objLabel').addEventListener('input', e => { obj.label = e.target.value; renderCanvasOnly(); });
          document.getElementById('deleteObjBtn').addEventListener('click', () => deleteStructure(obj.id));
          focusInspectorOnMobile();
          return;
        }

        if (selected.kind === 'point') {
          inspectorTitle.textContent = 'Fence Point';
          inspectorSub.textContent = 'Drag the point to refine the layout.';
          inspectorContent.innerHTML = `<div class="empty-state">Drag this point to adjust your layout. Tap Continue Fence to keep building from the last point until the perimeter is done.</div>`;
          focusInspectorOnMobile();
        }
      }

      function computeMaterials() {
        const grouped = {};
        const styleNames = [...new Set(segments.map(seg => seg.style))];

        styleNames.forEach(style => {
          const meta = getStyleMeta(style);
          const family = meta.family;
          const styleSegments = segments.filter(seg => seg.style === style);
          const componentCount = componentDataForStyle(style).length;
          const sections = componentSectionsForStyle(style);
          const cornerPosts = cornerCountForStyle(style);

          grouped[style] = {
            family, style, color: meta.color,
            totalLengthFt: 0, fenceLengthFt: 0, gateOpeningFt: 0, panels: sections, sections, segments: styleSegments.length, gates: 0,
            vinylPosts: 0, woodPosts: 0, woodRails2x4x8: 0, woodPickets: 0, woodGateRails: 0, woodGateBraces: 0, woodGatePickets: 0,
            woodPicketCoverageSqFt: 0, woodRailCoverageSqFt: 0, woodPostCoverageSqFt: 0, woodStainGallons: 0,
            aluminumLinePosts: 0, aluminumEndPosts: 0, aluminumCornerPosts: 0,
            chainLinkLinePosts: 0, chainLinkTerminalPosts: 0, chainLinkTopRailSticks: 0, chainLinkFabricRolls: 0,
            chainLinkTensionBands: 0, chainLinkBraceBands: 0, chainLinkRailEnds: 0, chainLinkNutsBolts: 0, chainLinkTieBags: 0,
            linePosts: 0, endPosts: 0, cornerPosts: cornerPosts, gateStiffeners: 0, hingeSets: 0, latchSets: 0,
            octoRings: 0, galvanizedPosts: 0, concreteBags: 0,
            installBreakdown: {}, notes: []
          };

          const g = grouped[style];
          const gateCount = styleSegments.reduce((sum, seg) => sum + ((seg.gates || []).length), 0);
          const gateOpenings = styleSegments.reduce((sum, seg) => sum + gateWidthTotal(seg), 0);
          const fenceLength = styleSegments.reduce((sum, seg) => sum + usableFenceLengthFt(seg), 0);
          const totalPosts = sections + componentCount + gateCount;
          const endPosts = (componentCount * 2) + (gateCount * 2);
          const linePosts = Math.max(0, totalPosts - endPosts - cornerPosts);

          g.totalLengthFt = round2(styleSegments.reduce((sum, seg) => sum + segmentLengthFeet(seg), 0));
          g.fenceLengthFt = round2(fenceLength);
          g.gateOpeningFt = round2(gateOpenings);
          g.gates = gateCount;
          g.linePosts = linePosts;
          g.endPosts = endPosts;
          g.cornerPosts = cornerPosts;
          g.gateStiffeners = gateCount;
          g.hingeSets = gateCount;
          g.latchSets = gateCount;

          styleSegments.forEach(seg => {
            if (seg.notes) g.notes.push(`S${segments.findIndex(s => s.id === seg.id) + 1}: ${seg.notes}`);
            seg.installMethod = normalizeInstallMethod(seg.installMethod);
            g.installBreakdown[seg.installMethod] = (g.installBreakdown[seg.installMethod] || 0) + 1;
            const gate = gateStats(seg);
            g.woodGateRails += gate.woodGateRails;
            g.woodGateBraces += gate.woodGateBraces;
            g.woodGatePickets += gate.woodGatePickets;
          });

          const installMethods = [...new Set(styleSegments.map(seg => normalizeInstallMethod(seg.installMethod)).filter(Boolean))];
          installMethods.forEach(method => {
            const subset = styleSegments.filter(seg => normalizeInstallMethod(seg.installMethod) === method);
            if (!subset.length) return;
            const subsetComponents = componentDataForSegments(subset).components.length;
            const subsetSections = componentSectionsForSegments(subset, meta.panelWidth);
            const subsetCorners = cornerCountForSegments(subset);
            const subsetGates = subset.reduce((sum, seg) => sum + ((seg.gates || []).length), 0);
            const subsetPosts = subsetSections + subsetComponents + subsetGates;

            if (method === 'No-Dig') {
              if (family === 'vinyl') g.octoRings += (subsetPosts * 2);
              if (family === 'vinyl' || family === 'aluminum') g.galvanizedPosts += subsetPosts;
            }
            if (method === 'Concrete Set') {
              g.concreteBags += subsetPosts * 2;
            }
            if (method === 'PostMaster') {
              // Keep PostMaster counts in the normal post totals; no extra line item needed here.
            }
          });

          if (family === 'vinyl') g.vinylPosts = totalPosts;

          if (family === 'wood') {
            const posts = totalPosts;
            const rails = sections * 3;
            const pickets = sections * (meta.picketsPerSection || 0);
            g.woodPosts = posts;
            g.woodRails2x4x8 = rails;
            g.woodPickets = pickets;
            g.woodPicketCoverageSqFt = pickets * 6.17 + g.woodGatePickets * 6.17;
            g.woodRailCoverageSqFt = rails * 6.74 + g.woodGateRails * 6.74 + g.woodGateBraces * 4.5;
            g.woodPostCoverageSqFt = posts * 9.5;
          }

          if (family === 'aluminum') {
            g.aluminumLinePosts = linePosts;
            g.aluminumEndPosts = endPosts;
            g.aluminumCornerPosts = cornerPosts;
          }

          if (family === 'chainlink') {
            const hookups = endPosts + (cornerPosts * 2);
            const tensionBandsPerHookup = Math.max(0, (meta.height || 0) - 1);
            g.chainLinkLinePosts = linePosts;
            g.chainLinkTerminalPosts = endPosts + cornerPosts;
            g.chainLinkTopRailSticks = Math.ceil(fenceLength / 21);
            g.chainLinkFabricRolls = Math.ceil(fenceLength / 50);
            g.chainLinkTensionBands = hookups * tensionBandsPerHookup;
            g.chainLinkBraceBands = hookups;
            g.chainLinkRailEnds = hookups;
            g.chainLinkNutsBolts = g.chainLinkTensionBands + g.chainLinkBraceBands;
            g.chainLinkTieBags = Math.ceil(fenceLength / 100);
          }
        });

        Object.values(grouped).forEach(g => {
          if (g.family === 'wood') {
            const totalSqFt = g.woodPicketCoverageSqFt + g.woodRailCoverageSqFt + g.woodPostCoverageSqFt;
            g.woodStainGallons = ceil2(totalSqFt / 350);
          }
        });

        return grouped;
      }

      function renderMaterials() {
        const grouped = computeMaterials();
        const styles = Object.keys(grouped);
        if (!styles.length) {
          materialsEmpty.hidden = false;
          materialsTableWrap.hidden = true;
          materialsBody.innerHTML = '';
          return;
        }

        const metricBlock = (label, value, note = '') => `
          <div class="metric">
            <span class="metric-label">${label}</span>
            <span class="metric-value">${value ?? 0}</span>
            ${note ? `<span class="metric-note">${note}</span>` : ''}
          </div>
        `;

        materialsBody.innerHTML = styles.map(style => {
          const row = grouped[style];
          const baseMetrics = [
            metricBlock('Fence length', `${row.fenceLengthFt} ft`, `${row.totalLengthFt} ft overall`),
            metricBlock('Sections', row.panels, `${row.segments} fence runs`),
            metricBlock('Gates', row.gates, `${row.gateOpeningFt} ft openings`),
            metricBlock('Hardware', `${row.hingeSets} hinge sets · ${row.latchSets} latches`, row.gateStiffeners ? `${row.gateStiffeners} stiffeners` : '')
          ];

          if (row.family === 'vinyl') {
            baseMetrics.push(
              metricBlock('Total posts', row.vinylPosts, `${row.linePosts} line · ${row.endPosts} end · ${row.cornerPosts} corner`)
            );
            if (row.galvanizedPosts || row.octoRings) {
              baseMetrics.push(metricBlock('Galv posts', row.galvanizedPosts, row.octoRings ? `${row.octoRings} octo rings` : ''));
            }
            if (row.concreteBags) {
              baseMetrics.push(metricBlock('Concrete', row.concreteBags, '80 lb bag estimate'));
            }
          }
          if (row.family === 'wood') {
            baseMetrics.push(
              metricBlock('Total posts', row.woodPosts, `${row.linePosts} line · ${row.endPosts} end · ${row.cornerPosts} corner`),
              metricBlock('Fence rails', row.woodRails2x4x8, '2x4 rails only'),
              metricBlock('Fence pickets', row.woodPickets, 'does not include gate pickets'),
              metricBlock('Gate build', `${row.woodGateRails} rails · ${row.woodGateBraces} braces`, `${row.woodGatePickets} gate pickets`)
            );
            if (row.concreteBags) {
              baseMetrics.push(metricBlock('Concrete', row.concreteBags, '80 lb bag estimate'));
            }
          }
          if (row.family === 'aluminum') {
            baseMetrics.push(
              metricBlock('Posts', `${row.aluminumLinePosts + row.aluminumEndPosts + row.aluminumCornerPosts}`, `${row.aluminumLinePosts} line · ${row.aluminumEndPosts} end · ${row.aluminumCornerPosts} corner`)
            );
            if (row.galvanizedPosts || row.octoRings) {
              baseMetrics.push(metricBlock('Galv posts', row.galvanizedPosts, row.octoRings ? `${row.octoRings} octo rings` : ''));
            }
            if (row.concreteBags) {
              baseMetrics.push(metricBlock('Concrete', row.concreteBags, '80 lb bag estimate'));
            }
          }
          if (row.family === 'chainlink') {
            baseMetrics.push(
              metricBlock('Line posts', row.chainLinkLinePosts, '1 5/8" line posts'),
              metricBlock('Terminal posts', row.chainLinkTerminalPosts, `${row.endPosts} end/gate · ${row.cornerPosts} corner`),
              metricBlock('Top rail', row.chainLinkTopRailSticks, '21 ft sticks · 1 3/8"'),
              metricBlock('Fabric rolls', row.chainLinkFabricRolls, '50 ft rolls'),
              metricBlock('Bands', `${row.chainLinkTensionBands} tension · ${row.chainLinkBraceBands} brace`, `${row.chainLinkRailEnds} rail ends · ${row.chainLinkNutsBolts} nut/bolt sets`),
              metricBlock('Ties', row.chainLinkTieBags, '1 bag per 100 ft')
            );
            if (row.concreteBags) {
              baseMetrics.push(metricBlock('Concrete', row.concreteBags, '80 lb bag estimate'));
            }
          }

          const install = Object.entries(row.installBreakdown || {}).map(([k,v]) => `${k}: ${v}`).join(' · ');
          const noteText = [install, ...(row.notes || [])].filter(Boolean).join(' | ');

          return `
            <article class="material-summary">
              <h3><span class="style-dot" style="background:${row.color}"></span>${style}</h3>
              <div class="material-metrics">${baseMetrics.join('')}</div>
              ${noteText ? `<div class="metric" style="margin-top:10px;"><span class="metric-label">Notes</span><span class="metric-note">${noteText}</span></div>` : ''}
            </article>
          `;
        }).join('');

        materialsEmpty.hidden = true;
        materialsTableWrap.hidden = false;
      }

      function deleteSegment(id) {
        pushHistory();
        const doomed = segmentById(id);
        if (!doomed) return;
        segments = segments.filter(s => s.id !== id);
        const used = new Set();
        segments.forEach(s => { used.add(s.startPointId); used.add(s.endPointId); });
        points = points.filter(p => used.has(p.id));
        selected = null;
        render();
      }

      function deleteStructure(id) {
        pushHistory();
        structures = structures.filter(s => s.id !== id);
        selected = null;
        render();
      }

      function hitFromTarget(target) {
        if (!target?.dataset) return null;
        if (target.dataset.type === 'segment') return { kind: 'segment', id: target.dataset.id };
        if (target.dataset.type === 'point') return { kind: 'point', id: target.dataset.id };
        if (target.dataset.type === 'structure') return { kind: 'structure', id: target.dataset.id };
        if (target.dataset.type === 'resize') return { kind: 'resize', id: target.dataset.id };
        if (target.dataset.type === 'gate') return { kind: 'gate', segmentId: target.dataset.segmentId, gateId: target.dataset.gateId };
        return null;
      }

      function handleCanvasTap(world, hit) {
        if (interactionMode === 'draw-start' && !hit) {
          pushHistory();
          addPoint(world);
          selected = null;
          previewPoint = null;
          setMode('draw-continue', 'Drawing Fence', 'Keep clicking or tapping around the property until finished.');
          render();
          return true;
        }

        if (interactionMode === 'draw-continue' && hit?.kind === 'point') {
          finishDrawing();
          return true;
        }

        if (interactionMode === 'draw-continue' && !hit) {
          pushHistory();
          if (!points.length) {
            addPoint(world);
            selected = null;
          } else {
            const last = getLastPoint();
            const next = addPoint(world);
            addSegment(last.id, next.id);
            selected = null;
          }
          previewPoint = null;
          setMode('draw-continue', 'Drawing Fence', 'Keep going until the perimeter is finished.');
          render();
          return true;
        }

        if (interactionMode.startsWith('add-') && !hit) {
          pushHistory();
          const type = interactionMode.replace('add-', '');
          const obj = getStructureTemplate(type, world);
          structures.push(obj);
          selected = { kind: 'structure', id: obj.id };
          setMode('idle', 'Object Placed', 'Tap or drag items directly.');
          objectsPanel.hidden = true;
          render();
          return true;
        }

        return false;
      }

      function onPointerDown(evt) {
        if (evt.pointerType !== 'mouse' || evt.button === 0) evt.preventDefault();
        const world = screenToWorld(evt.clientX, evt.clientY);
        const hit = hitFromTarget(evt.target);

        if (handleCanvasTap(world, hit)) return;

        if (hit?.kind === 'resize') {
          selected = { kind: 'structure', id: hit.id };
          dragState = { type: 'resize-structure', id: hit.id };
          renderInspector();
          return;
        }

        if (hit?.kind === 'gate') {
          selected = { kind: 'gate', segmentId: hit.segmentId, gateId: hit.gateId };
          dragState = { type: 'move-gate', segmentId: hit.segmentId, gateId: hit.gateId };
          renderInspector();
          return;
        }

        if (hit?.kind === 'structure') {
          selected = { kind: 'structure', id: hit.id };
          const obj = structureById(hit.id);
          dragState = { type: 'move-structure', id: hit.id, offsetX: world.x - obj.x, offsetY: world.y - obj.y };
          renderInspector();
          return;
        }

        if (hit?.kind === 'point') {
          selected = { kind: 'point', id: hit.id };
          dragState = { type: 'move-point', id: hit.id };
          renderInspector();
          return;
        }

        if (hit?.kind === 'segment') {
          selected = { kind: 'segment', id: hit.id };
          const seg = segmentById(hit.id);
          const { a, b } = getSegmentPoints(seg);
          dragState = { type: 'move-segment', startPointId: seg.startPointId, endPointId: seg.endPointId, startA: { ...a }, startB: { ...b }, anchor: world };
          renderInspector();
          return;
        }

        selected = null;
        dragState = { type: 'pan', startClientX: evt.clientX, startClientY: evt.clientY, startCameraX: camera.x, startCameraY: camera.y };
        renderInspector();
      }

      function onPointerMove(evt) {
        const world = screenToWorld(evt.clientX, evt.clientY);

        if (interactionMode === 'draw-continue' && points.length) {
          previewPoint = world;
          renderCanvasOnly();
        }

        if (!dragState) return;
        evt.preventDefault();

        if (dragState.type === 'pan') {
          camera.x = dragState.startCameraX + (evt.clientX - dragState.startClientX);
          camera.y = dragState.startCameraY + (evt.clientY - dragState.startClientY);
          renderCanvasOnly();
          return;
        }

        if (dragState.type === 'move-point') {
          const p = pointById(dragState.id);
          if (!p) return;
          p.x = clamp(world.x, 0, 1800);
          p.y = clamp(world.y, 0, 1100);
          renderCanvasOnly();
          renderMaterials();
          return;
        }

        if (dragState.type === 'move-segment') {
          const a = pointById(dragState.startPointId);
          const b = pointById(dragState.endPointId);
          if (!a || !b) return;
          const dx = world.x - dragState.anchor.x;
          const dy = world.y - dragState.anchor.y;
          a.x = clamp(dragState.startA.x + dx, 0, 1800);
          a.y = clamp(dragState.startA.y + dy, 0, 1100);
          b.x = clamp(dragState.startB.x + dx, 0, 1800);
          b.y = clamp(dragState.startB.y + dy, 0, 1100);
          renderCanvasOnly();
          renderMaterials();
          return;
        }

        if (dragState.type === 'move-structure') {
          const obj = structureById(dragState.id);
          if (!obj) return;
          if (obj.size) {
            obj.x = clamp(world.x - dragState.offsetX, 20, 1780);
            obj.y = clamp(world.y - dragState.offsetY, 20, 1080);
          } else {
            obj.x = clamp(world.x - dragState.offsetX, 0, 1800 - obj.width);
            obj.y = clamp(world.y - dragState.offsetY, 0, 1100 - obj.height);
          }
          renderCanvasOnly();
          return;
        }

        if (dragState.type === 'resize-structure') {
          const obj = structureById(dragState.id);
          if (!obj) return;
          if (obj.size) {
            obj.size = Math.max(16, Math.round(Math.abs(world.x - obj.x)));
          } else {
            obj.width = Math.max(36, Math.round(world.x - obj.x));
            obj.height = Math.max(36, Math.round(world.y - obj.y));
          }
          renderCanvasOnly();
          return;
        }

        if (dragState.type === 'move-gate') {
          const seg = segmentById(dragState.segmentId);
          const gate = seg?.gates?.find(g => g.id === dragState.gateId);
          if (!seg || !gate) return;
          const { a, b } = getSegmentPoints(seg);
          gate.position = projectPointToSegment(world.x, world.y, a.x, a.y, b.x, b.y);
          renderCanvasOnly();
        }
      }

      function onPointerUp() { dragState = null; }

      function onWheel(evt) {
        evt.preventDefault();
        const pt = svg.createSVGPoint();
        pt.x = evt.clientX;
        pt.y = evt.clientY;
        const local = pt.matrixTransform(svg.getScreenCTM().inverse());
        const world = screenToWorld(evt.clientX, evt.clientY);
        const factor = evt.deltaY < 0 ? 1.1 : 0.9;
        const newScale = clamp(camera.scale * factor, camera.minScale, camera.maxScale);
        if (newScale === camera.scale) return;
        camera.x = local.x - world.x * newScale;
        camera.y = local.y - world.y * newScale;
        camera.scale = newScale;
        renderCanvasOnly();
      }

      function getTouchDistance(t1, t2) { return Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY); }
      function getTouchMid(t1, t2) { return { x: (t1.clientX + t2.clientX) / 2, y: (t1.clientY + t2.clientY) / 2 }; }

      svg.addEventListener('touchstart', e => {
        if (e.touches.length === 2) {
          e.preventDefault();
          pinchState = {
            distance: getTouchDistance(e.touches[0], e.touches[1]),
            scale: camera.scale,
            x: camera.x,
            y: camera.y,
            mid: getTouchMid(e.touches[0], e.touches[1])
          };
        }
      }, { passive: false });

      svg.addEventListener('touchmove', e => {
        if (e.touches.length === 2 && pinchState) {
          e.preventDefault();
          const newDistance = getTouchDistance(e.touches[0], e.touches[1]);
          const factor = newDistance / pinchState.distance;
          camera.scale = clamp(pinchState.scale * factor, camera.minScale, camera.maxScale);
          const newMid = getTouchMid(e.touches[0], e.touches[1]);
          camera.x = pinchState.x + (newMid.x - pinchState.mid.x);
          camera.y = pinchState.y + (newMid.y - pinchState.mid.y);
          renderCanvasOnly();
        }
      }, { passive: false });

      svg.addEventListener('touchend', e => { if (pinchState && e.touches.length < 2) pinchState = null; });


      async function loadImageAsDataUrl(src) {
        if (!src) return null;
        try {
          const response = await fetch(src, { mode: 'cors', cache: 'force-cache' });
          const blob = await response.blob();
          return await new Promise(resolve => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });
        } catch (error) {
          return null;
        }
      }


      async function ensureJsPdf() {
        if (window.jspdf?.jsPDF) return window.jspdf.jsPDF;
        await new Promise((resolve, reject) => {
          const existing = document.querySelector('script[data-mdwst-jspdf="true"]');
          if (existing) {
            existing.addEventListener('load', () => resolve(), { once: true });
            existing.addEventListener('error', () => reject(new Error('jsPDF failed to load.')), { once: true });
            return;
          }
          const script = document.createElement('script');
          script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
          script.defer = true;
          script.dataset.mdwstJspdf = 'true';
          script.onload = () => resolve();
          script.onerror = () => reject(new Error('jsPDF failed to load.'));
          document.head.appendChild(script);
        });
        return window.jspdf?.jsPDF || null;
      }

      async function assetUrlToDataUrl(url) {
        if (!url) return null;
        if (String(url).startsWith('data:')) return url;
        const response = await fetch(url, { mode: 'cors', credentials: 'same-origin' });
        if (!response.ok) throw new Error('Logo could not be fetched.');
        const blob = await response.blob();
        return await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onloadend = () => resolve(reader.result);
          reader.onerror = () => reject(new Error('Logo could not be read.'));
          reader.readAsDataURL(blob);
        });
      }

      async function svgToPngDataUrl(svgNode, width = 1400, height = 800) {
        const clone = svgNode.cloneNode(true);
        clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        clone.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');
        clone.setAttribute('width', String(width));
        clone.setAttribute('height', String(height));
        clone.setAttribute('viewBox', '0 0 1800 1100');
        const serialized = new XMLSerializer().serializeToString(clone);
        const blob = new Blob([serialized], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        try {
          return await new Promise((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
              const canvas = document.createElement('canvas');
              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext('2d');
              ctx.fillStyle = '#ffffff';
              ctx.fillRect(0, 0, width, height);
              ctx.drawImage(img, 0, 0, width, height);
              resolve(canvas.toDataURL('image/png'));
            };
            img.onerror = reject;
            img.src = url;
          });
        } finally {
          URL.revokeObjectURL(url);
        }
      }

      function getBrandLogoSrc() {
        return BRAND_LOGO_DATA_URL;
      }

      function exportReportPrintFallback() {
        alert('PDF export could not load. Please refresh the page and try again.');
      }

      function firstExportField(selectors = []) {
        for (const selector of selectors) {
          const el = document.querySelector(selector);
          if (!el) continue;
          const raw = ('value' in el ? el.value : el.textContent) || '';
          const value = String(raw).trim();
          if (value) return value;
        }
        return '';
      }

      function getPdfCustomerInfo() {
        return {
          customerName: firstExportField([
            '#customerName', '#quoteCustomerName', '#estCustomerName',
            'input[name="customerName"]', 'input[name="customer_name"]',
            '[data-export-customer-name]'
          ]),
          phone: firstExportField([
            '#customerPhone', '#quotePhone', '#estCustomerPhone',
            'input[name="customerPhone"]', 'input[name="customer_phone"]',
            'input[name="phone"]', '[data-export-customer-phone]'
          ]),
          email: firstExportField([
            '#customerEmail', '#quoteEmail', '#estCustomerEmail',
            'input[name="customerEmail"]', 'input[name="customer_email"]',
            'input[name="email"]', '[data-export-customer-email]'
          ]),
          projectName: firstExportField([
            '#projectName', '#jobName', '#quoteProjectName', '#estProjectName',
            'input[name="projectName"]', 'input[name="project_name"]',
            '[data-export-project-name]'
          ]),
          address: firstExportField([
            '#projectAddress', '#customerAddress', '#quoteAddress', '#estProjectAddress',
            'input[name="projectAddress"]', 'input[name="project_address"]',
            'input[name="address"]', 'textarea[name="address"]',
            '[data-export-project-address]'
          ])
        };
      }

      
      
      async function exportReport() {
        const grouped = computeMaterials();
        const pdfCustomerInfo = getPdfCustomerInfo();
        let jsPDFCtor;
        try {
          jsPDFCtor = await ensureJsPdf();
        } catch (error) {
          console.error(error);
          exportReportPrintFallback();
          return;
        }
        if (!jsPDFCtor) {
          exportReportPrintFallback();
          return;
        }

        const doc = new jsPDFCtor({ orientation: 'portrait', unit: 'pt', format: 'letter', compress: true });
        const pageW = doc.internal.pageSize.getWidth();
        const pageH = doc.internal.pageSize.getHeight();
        const margin = 38;
        const contentW = pageW - (margin * 2);
        const bodyBottom = pageH - 42;
        const now = new Date();
        const dateStamp = now.toLocaleDateString();
        const timeStamp = now.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
        const estimateNo = `EST-${now.getFullYear()}${String(now.getMonth()+1).padStart(2,'0')}${String(now.getDate()).padStart(2,'0')}-${String(now.getHours()).padStart(2,'0')}${String(now.getMinutes()).padStart(2,'0')}`;
        const logoDataUrl = await assetUrlToDataUrl(BRAND_LOGO_ASSET_URL).catch((error) => {
          console.warn('MDWST logo could not be embedded in export.', error);
          return null;
        });
        const drawingDataUrl = await svgToPngDataUrl(svg, 1700, 1000).catch((error) => {
          console.warn('Drawing preview could not be embedded in export.', error);
          return null;
        });
        const totalFenceLength = round2(segments.reduce((sum, seg) => sum + usableFenceLengthFt(seg), 0));
        const totalLength = round2(segments.reduce((sum, seg) => sum + segmentLengthFeet(seg), 0));
        const totalGates = segments.reduce((sum, seg) => sum + ((seg.gates || []).length), 0);
        const totalSections = Object.values(grouped).reduce((sum, row) => sum + (row.sections || 0), 0);
        const totalPosts = Object.values(grouped).reduce((sum, row) => {
          if (row.family === 'vinyl') return sum + (row.vinylPosts || 0);
          if (row.family === 'wood') return sum + (row.woodPosts || 0);
          return sum + (row.linePosts || 0) + (row.endPosts || 0) + (row.cornerPosts || 0);
        }, 0);

        let cursorY = 0;

        function addFooter() {
          doc.setDrawColor(220, 224, 230);
          doc.line(margin, pageH - 28, pageW - margin, pageH - 28);
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(8.5);
          doc.setTextColor(95, 99, 104);
          doc.text(`${BRAND_INFO.company} • ${BRAND_INFO.address1}, ${BRAND_INFO.cityStateZip} • ${BRAND_INFO.phone} • ${BRAND_INFO.website}`, margin, pageH - 15);
          doc.text(`Page ${doc.getNumberOfPages()}`, pageW - margin, pageH - 15, { align: 'right' });
        }

        function setupPage() {
          doc.setFillColor(255, 255, 255);
          doc.rect(0, 0, pageW, pageH, 'F');
          addFooter();
          cursorY = margin;
        }

        function nextPage() {
          doc.addPage('letter', 'portrait');
          setupPage();
        }

        function ensureSpace(needed) {
          if (cursorY + needed <= bodyBottom) return;
          nextPage();
        }

        function lineLabelValue(label, value, x, y, labelW = 58) {
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(9.5);
          doc.setTextColor(55, 65, 81);
          doc.text(label, x, y);
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(23, 23, 23);
          doc.text(String(value || '-'), x + labelW, y);
        }

        function drawHeader() {
          doc.setDrawColor(190, 196, 204);
          doc.setLineWidth(1);
          doc.rect(margin, cursorY, contentW, 102);
          doc.line(margin, cursorY + 102, pageW - margin, cursorY + 102);

          const logoBoxX = margin + 10;
          const logoBoxY = cursorY + 10;
          const logoBoxW = 190;
          const logoBoxH = 44;
          if (logoDataUrl) {
            try {
              doc.addImage(logoDataUrl, 'PNG', logoBoxX, logoBoxY, logoBoxW, logoBoxH, undefined, 'FAST');
            } catch (error) {
              try {
                doc.addImage(logoDataUrl, 'JPEG', logoBoxX, logoBoxY, logoBoxW, logoBoxH, undefined, 'FAST');
              } catch (error2) {
                doc.setFont('helvetica', 'bold');
                doc.setFontSize(22);
                doc.setTextColor(17, 24, 39);
                doc.text(BRAND_INFO.company, logoBoxX, logoBoxY + 28);
              }
            }
          } else {
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(22);
            doc.setTextColor(17, 24, 39);
            doc.text(BRAND_INFO.company, logoBoxX, logoBoxY + 28);
          }

          doc.setFont('helvetica', 'normal');
          doc.setFontSize(9.25);
          doc.setTextColor(55, 65, 81);
          const headerInfoX = logoBoxX;
          const headerInfoY = cursorY + 64;
          const headerInfoW = 300;
          const addrLine = `${BRAND_INFO.address1}, ${BRAND_INFO.cityStateZip}`;
          const contactLine = `${BRAND_INFO.phone} • ${BRAND_INFO.email} • ${BRAND_INFO.website}`;
          doc.text(BRAND_INFO.company, headerInfoX, headerInfoY);
          doc.text(doc.splitTextToSize(addrLine, headerInfoW), headerInfoX, headerInfoY + 12);
          doc.text(doc.splitTextToSize(contactLine, headerInfoW), headerInfoX, headerInfoY + 24);

          const rightX = pageW - margin - 192;
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(24);
          doc.setTextColor(17, 24, 39);
          doc.text('Estimate', pageW - margin - 8, cursorY + 28, { align: 'right' });
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(9.5);
          doc.setTextColor(55, 65, 81);
          doc.text(`Prepared ${dateStamp} at ${timeStamp}`, pageW - margin - 8, cursorY + 44, { align: 'right' });
          doc.rect(rightX, cursorY + 60, 92, 28);
          doc.rect(rightX + 92, cursorY + 60, 100, 28);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(9);
          doc.text('Date', rightX + 46, cursorY + 72, { align: 'center' });
          doc.text('Estimate #', rightX + 142, cursorY + 72, { align: 'center' });
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(9.5);
          doc.text(dateStamp, rightX + 46, cursorY + 84, { align: 'center' });
          doc.text(estimateNo, rightX + 142, cursorY + 84, { align: 'center' });

          cursorY += 118;
        }

        function drawSummaryBoxes() {
          const boxGap = 12;
          const boxW = (contentW - boxGap) / 2;
          const boxH = 94;
          doc.setDrawColor(190, 196, 204);
          doc.rect(margin, cursorY, boxW, boxH);
          doc.rect(margin + boxW + boxGap, cursorY, boxW, boxH);
          doc.setFillColor(247, 248, 250);
          doc.rect(margin, cursorY, boxW, 24, 'F');
          doc.rect(margin + boxW + boxGap, cursorY, boxW, 24, 'F');
          doc.rect(margin, cursorY, boxW, 24);
          doc.rect(margin + boxW + boxGap, cursorY, boxW, 24);
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(10.5);
          doc.setTextColor(17, 24, 39);
          doc.text('Prepared By', margin + 10, cursorY + 16);
          doc.text('Project Snapshot', margin + boxW + boxGap + 10, cursorY + 16);

          lineLabelValue('Company', BRAND_INFO.company, margin + 10, cursorY + 40);
          lineLabelValue('Address', BRAND_INFO.address1, margin + 10, cursorY + 56);
          lineLabelValue('City / ST', BRAND_INFO.cityStateZip, margin + 10, cursorY + 72);
          lineLabelValue('Phone', BRAND_INFO.phone, margin + 10, cursorY + 88);

          const snapX = margin + boxW + boxGap + 10;
          lineLabelValue('Fence', `${totalFenceLength} ft`, snapX, cursorY + 40);
          lineLabelValue('Overall', `${totalLength} ft`, snapX, cursorY + 56);
          lineLabelValue('Sections', totalSections, snapX, cursorY + 72);
          lineLabelValue('Posts', totalPosts, snapX, cursorY + 88);
          lineLabelValue('Gates', totalGates, snapX + 145, cursorY + 72, 42);

          cursorY += boxH + 14;
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(8.8);
          doc.setTextColor(107, 114, 128);
          doc.text('This estimate is intended to be easy to review. Please confirm final measurements, site conditions, gate swing, and product selections before ordering.', margin, cursorY);
          cursorY += 14;
        }

        function sectionBar(title) {
          ensureSpace(28);
          doc.setFillColor(247, 248, 250);
          doc.setDrawColor(190, 196, 204);
          doc.rect(margin, cursorY, contentW, 22, 'FD');
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(11);
          doc.setTextColor(17, 24, 39);
          doc.text(title, margin + 8, cursorY + 14);
          cursorY += 30;
        }

        function drawTable(headers, rows, widths, opts = {}) {
          const padX = 4;
          const padY = 4;
          const baseRowH = opts.rowHeight || 18;
          const scale = contentW / widths.reduce((a, b) => a + b, 0);
          widths = widths.map(w => w * scale);

          const drawHead = () => {
            let x = margin;
            doc.setFillColor(247, 248, 250);
            doc.setDrawColor(190, 196, 204);
            headers.forEach((h, i) => {
              doc.rect(x, cursorY, widths[i], baseRowH, 'FD');
              doc.setFont('helvetica', 'bold');
              doc.setFontSize(8.8);
              doc.setTextColor(17, 24, 39);
              doc.text(String(h), x + padX, cursorY + 12);
              x += widths[i];
            });
            cursorY += baseRowH;
          };

          ensureSpace(baseRowH + 8);
          drawHead();

          rows.forEach(row => {
            const cells = row.map((cell, i) => doc.splitTextToSize(String(cell ?? ''), widths[i] - (padX * 2)));
            const rowH = Math.max(baseRowH, ...cells.map(lines => (lines.length * 9) + (padY * 2)));
            ensureSpace(rowH + 2);
            if (cursorY === margin) drawHead();
            let x = margin;
            row.forEach((cell, i) => {
              doc.setDrawColor(205, 209, 214);
              doc.rect(x, cursorY, widths[i], rowH);
              doc.setFont('helvetica', 'normal');
              doc.setFontSize(8.5);
              doc.setTextColor(31, 41, 55);
              doc.text(cells[i], x + padX, cursorY + 10);
              x += widths[i];
            });
            cursorY += rowH;
          });
          cursorY += 8;
        }

        function materialLineItems() {
          const items = [];
          Object.values(grouped).forEach(row => {
            items.push([
              row.style,
              'Fence sections',
              row.sections || 0,
              'ea',
              `${row.fenceLengthFt} lf of fence`
            ]);

            const totalStylePosts = row.family === 'vinyl'
              ? (row.vinylPosts || 0)
              : row.family === 'wood'
                ? (row.woodPosts || 0)
                : ((row.linePosts || 0) + (row.endPosts || 0) + (row.cornerPosts || 0));
            if (totalStylePosts) {
              items.push([
                row.style,
                'Posts',
                totalStylePosts,
                'ea',
                `${row.linePosts || 0} line • ${row.endPosts || 0} end • ${row.cornerPosts || 0} corner`
              ]);
            }
            if (row.octoRings) items.push([row.style, 'Octo rings', row.octoRings, 'ea', 'Required for no-dig installs']);
            if (row.galvanizedPosts) items.push([row.style, 'Galvanized round posts', row.galvanizedPosts, 'ea', 'For no-dig / octo ring installs only']);
            if (row.concreteBags) items.push([row.style, 'Concrete bags', row.concreteBags, 'bags', 'Estimated at 2 bags per concrete-set post']);
            if (row.family === 'wood' && row.woodRails2x4x8) items.push([row.style, '2x4x8 rails', row.woodRails2x4x8, 'ea', '3 rails per section']);
            if (row.family === 'wood' && row.woodPickets) items.push([row.style, 'Wood pickets', row.woodPickets, 'ea', 'Fence only - excludes gate pickets']);
            if (row.gates) items.push([row.style, 'Gate hardware', row.gates, 'set', `${row.hingeSets || 0} hinge sets • ${row.latchSets || 0} latches • ${row.gateStiffeners || 0} stiffeners`]);
            if (row.family === 'wood' && row.woodGateRails) items.push([row.style, 'Gate build lumber', row.woodGateRails, 'rail', `${row.woodGateBraces || 0} diagonal braces • ${row.woodGatePickets || 0} gate pickets`]);
          });
          return items;
        }

        function segmentRows() {
          return segments.map((seg, idx) => {
            const gates = seg.gates || [];
            const gateText = gates.length
              ? gates.map((g, i) => `Gate ${i + 1}: ${g.width} ft ${g.swing || 'Swing'}`).join(' • ')
              : 'None';
            return [
              idx + 1,
              seg.style,
              `${segmentLengthFeet(seg)} ft`,
              seg.installMethod || '-',
              getPanels(seg),
              gateText,
              seg.notes || '-'
            ];
          });
        }

        function totalsRows() { /* cleaned spacing */
          const rows = [
            ['Fence length', `${totalFenceLength} ft`],
            ['Overall layout', `${totalLength} ft`],
            ['Sections', String(totalSections)],
            ['Posts', String(totalPosts)],
            ['Gates', String(totalGates)]
          ];
          if (pdfCustomerInfo.customerName) rows.push(['Customer', pdfCustomerInfo.customerName]);
          if (pdfCustomerInfo.phone) rows.push(['Phone', pdfCustomerInfo.phone]);
          if (pdfCustomerInfo.email) rows.push(['Email', pdfCustomerInfo.email]);
          if (pdfCustomerInfo.projectName) rows.push(['Project', pdfCustomerInfo.projectName]);
          if (pdfCustomerInfo.address) rows.push(['Address', pdfCustomerInfo.address]);
          Object.values(grouped).forEach(row => {
            rows.push([`${row.style} install`, Object.keys(row.installBreakdown).map(k => `${k}: ${row.installBreakdown[k]}`).join(' • ') || '-']);
          });
          return rows;
        }

        setupPage();
        drawHeader();
        drawSummaryBoxes();

        sectionBar('Material List');
        drawTable(
          ['Style', 'Description', 'Qty', 'U/M', 'Notes'],
          materialLineItems().length ? materialLineItems() : [['-', 'No materials calculated', '-', '-', 'Add segments to generate materials']],
          [92, 212, 52, 44, 170],
          { rowHeight: 18 }
        );

        ensureSpace(260);
        const lowerStartY = cursorY;
        const drawBoxW = 318;
        const totalsBoxX = margin + drawBoxW + 12;
        const totalsBoxW = contentW - drawBoxW - 12;

        doc.setDrawColor(190, 196, 204);
        doc.setFillColor(255, 255, 255);
        doc.rect(margin, lowerStartY, drawBoxW, 220);
        doc.setFillColor(247, 248, 250);
        doc.rect(margin, lowerStartY, drawBoxW, 22, 'F');
        doc.rect(margin, lowerStartY, drawBoxW, 22);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(11);
        doc.setTextColor(17, 24, 39);
        doc.text('Fence Layout', margin + 8, lowerStartY + 14);
        if (drawingDataUrl) {
          try {
            doc.addImage(drawingDataUrl, 'PNG', margin + 10, lowerStartY + 28, drawBoxW - 20, 176, undefined, 'FAST');
          } catch (error) {
            doc.setFont('helvetica', 'normal');
            doc.setFontSize(9);
            doc.setTextColor(107, 114, 128);
            doc.text('Layout preview unavailable for this export.', margin + 12, lowerStartY + 42);
          }
        } else {
          doc.setFont('helvetica', 'normal');
          doc.setFontSize(9);
          doc.setTextColor(107, 114, 128);
          doc.text('Layout preview unavailable for this export.', margin + 12, lowerStartY + 42);
        }

        doc.rect(totalsBoxX, lowerStartY, totalsBoxW, 220);
        doc.setFillColor(247, 248, 250);
        doc.rect(totalsBoxX, lowerStartY, totalsBoxW, 22, 'F');
        doc.rect(totalsBoxX, lowerStartY, totalsBoxW, 22);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(11);
        doc.setTextColor(17, 24, 39);
        doc.text('Estimate Summary', totalsBoxX + 8, lowerStartY + 14);

        let ty = lowerStartY + 38;
        totalsRows().forEach(([label, value], idx) => {
          doc.setFont('helvetica', 'bold');
          doc.setFontSize(9.3);
          doc.setTextColor(55, 65, 81);
          doc.text(label, totalsBoxX + 10, ty);
          doc.setFont('helvetica', 'normal');
          doc.setTextColor(17, 24, 39);
          const wrapped = doc.splitTextToSize(String(value), totalsBoxW - 110);
          doc.text(wrapped, totalsBoxX + 92, ty);
          ty += Math.max(16, 10 + (wrapped.length - 1) * 9);
          doc.setDrawColor(230, 232, 235);
          doc.line(totalsBoxX + 10, ty - 8, totalsBoxX + totalsBoxW - 10, ty - 8);
        });
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8.6);
        doc.setTextColor(107, 114, 128);
        doc.text('Materials are intended to be easy to review for customers and field teams. Final order quantities should still be confirmed before production or delivery.', totalsBoxX + 10, lowerStartY + 194, { maxWidth: totalsBoxW - 20 });

        cursorY = lowerStartY + 236;

        sectionBar('Segment Details');
        drawTable(
          ['#', 'Style', 'Length', 'Install', 'Sections', 'Gate Details', 'Notes'],
          segmentRows().length ? segmentRows() : [['-', '-', '-', '-', '-', 'No segments added', '-']],
          [26, 110, 54, 92, 48, 182, 84],
          { rowHeight: 18 }
        );

        ensureSpace(74);
        doc.setDrawColor(190, 196, 204);
        doc.rect(margin, cursorY, contentW, 54);
        doc.setFont('helvetica', 'bold');
        doc.setFontSize(10.5);
        doc.setTextColor(17, 24, 39);
        doc.text('Customer Review', margin + 10, cursorY + 16);
        doc.setFont('helvetica', 'normal');
        doc.setFontSize(8.8);
        doc.setTextColor(55, 65, 81);
        doc.text('Please review the layout, material list, gate swing, and install method. This report is a planning tool and should be field-verified before any order is finalized.', margin + 10, cursorY + 32, { maxWidth: contentW - 190 });
        doc.line(pageW - margin - 160, cursorY + 42, pageW - margin - 10, cursorY + 42);
        doc.setFontSize(8.2);
        doc.text('Approved / Verified', pageW - margin - 85, cursorY + 52, { align: 'center' });

        doc.text(getPdfDisclaimer(), 20, doc.internal.pageSize.height - 20);
        doc.save(`mdwst-estimate-${estimateNo}.pdf`);
      }


      drawModeSelect?.addEventListener('change', e => {
        const value = e.target.value;
        if (value === 'draw-start') {
          setMode('draw-start', 'Start Fence', 'Tap to place the first point.');
        } else if (value === 'draw-continue') {
          setMode('draw-continue', points.length ? 'Continue Fence' : 'Start Fence', points.length ? 'Keep clicking or tapping around the property until finished, or tap Finish to exit drawing mode.' : 'Tap to place the first point.');
        } else {
          finishDrawing();
        }
      });
      finishFenceBtn?.addEventListener('click', finishDrawing);
      objectsMenuBtn.addEventListener('click', () => { objectsPanel.hidden = !objectsPanel.hidden; objectsMenuBtn.classList.toggle('active', !objectsPanel.hidden); });
      objectsPanel.querySelectorAll('[data-object]').forEach(btn => btn.addEventListener('click', () => { setMode(`add-${btn.dataset.object}`, 'Place Structure', `Tap the drawing area to place ${btn.textContent}.`); if (window.innerWidth <= 760) sidebar.classList.remove('open'); }));
      toggleDimensionsBtn.addEventListener('click', () => { dimensionsVisible = !dimensionsVisible; toggleDimensionsBtn.classList.toggle('active', dimensionsVisible); renderCanvasOnly(); });
      undoBtn.addEventListener('click', () => restoreState(history.pop()));
      resetBtn.addEventListener('click', () => { points = []; segments = []; structures = []; selected = null; previewPoint = null; history = []; dimensionsVisible = true; camera.x = 0; camera.y = 0; camera.scale = 1; setMode('idle', 'Ready', 'Draw around the property until finished.'); render(); });
      deleteBtn?.addEventListener('click', deleteSelection);
      exportBtn.addEventListener('click', async () => {
        const originalText = exportBtn.textContent;
        exportBtn.disabled = true;
        exportBtn.textContent = 'Exporting…';
        try {
          await exportReport();
        } catch (error) {
          console.error('Export failed.', error);
          alert('PDF export failed. Please refresh the page and try again.');
        } finally {
          exportBtn.disabled = false;
          exportBtn.textContent = originalText;
        }
      });

      document.addEventListener('keydown', e => {
        const tag = (document.activeElement?.tagName || '').toLowerCase();
        const typing = ['input', 'textarea', 'select'].includes(tag) || document.activeElement?.isContentEditable;
        if (typing) return;

        const mod = e.ctrlKey || e.metaKey;
        if (mod && e.key.toLowerCase() === 'c') {
          e.preventDefault();
          copySelection();
          return;
        }
        if (mod && e.key.toLowerCase() === 'v') {
          e.preventDefault();
          pasteSelection();
          return;
        }
        if (e.key === 'Delete' || e.key === 'Backspace') {
          e.preventDefault();
          deleteSelection();
          return;
        }
        if (e.key === 'Escape') {
          finishDrawing();
        }
      });
      zoomInBtn.addEventListener('click', () => { camera.scale = clamp(camera.scale * 1.15, camera.minScale, camera.maxScale); renderCanvasOnly(); });
      zoomOutBtn.addEventListener('click', () => { camera.scale = clamp(camera.scale * 0.87, camera.minScale, camera.maxScale); renderCanvasOnly(); });
      zoomResetBtn.addEventListener('click', () => { camera.x = 0; camera.y = 0; camera.scale = 1; renderCanvasOnly(); });
      mobileDrawerToggle.addEventListener('click', () => {
        if (window.innerWidth <= 760) return;
        layout.classList.toggle('sidebar-hidden');
        const hidden = layout.classList.contains('sidebar-hidden');
        mobileDrawerToggle.classList.toggle('active', !hidden);
        mobileDrawerToggle.setAttribute('aria-label', hidden ? 'Show project controls' : 'Hide project controls');
        mobileDrawerToggle.textContent = hidden ? '☰' : '☷';
      });

      svg.addEventListener('pointerdown', onPointerDown);
      svg.addEventListener('pointermove', onPointerMove);
      svg.addEventListener('pointerup', onPointerUp);
      svg.addEventListener('pointerleave', onPointerUp);
      svg.addEventListener('wheel', onWheel, { passive: false });

      window.addEventListener('resize', () => {
        if (window.innerWidth <= 760) {
          layout.classList.remove('sidebar-hidden');
        }
        mobileDrawerToggle.textContent = layout.classList.contains('sidebar-hidden') ? '☰' : '☷';
      });

      setMode('idle', 'Ready', 'Draw around the property until finished.');
      mobileDrawerToggle.textContent = '☷';
      render();
    })();

// CUSTOMER DISCLAIMER ADDED
function getPdfDisclaimer(){
  return "Customer should double check all materials before ordering.";
}
